export default "__VITE_ASSET__DR$Uwfdm__"